import React from 'react'
import { Box, BoxProps } from '@chakra-ui/core'
import { MessageSkeleton } from 'components/ui/MessageSkeleton'
import styles from './CommentsContentLoader.module.css'

interface IProps extends BoxProps {
  count?: number
}

// A full initial history is scrollable; pagination callers pass the size of the requested page.
const CommentsContentLoader: React.FC<IProps> = ({ count = 16, ...props }) => (
  <Box role="status" aria-label="Loading comments" className={styles.list} {...props}>
    {Array.from({ length: count }, (_, index) => (
      <MessageSkeleton key={index} className={styles.message} />
    ))}
  </Box>
)

export default CommentsContentLoader
